import React from 'react';
import { Label } from '../atoms/label';
export const Explanation = (props) => {
    return(
        <div>
            <Label label={props.title} style={styles.title} />
            <Label label={props.value} style={styles.value} />        
        </div>
    );
}
const styles={
    title:{
        fontWeight: "bold",
        paddingRight: "20px",
        paddingTop: "30px",
        fontSize: "small",
        width: "100%",
    },
    value: {
        fontSize: "small",
        paddingBottom: "20px",
        whiteSpace:"break-spaces",
        margin: "0",
        fontFamily: "unset",
    },
}